import { APIStatus } from '@application/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { getAllUserCompaniesAsync, getAllCompaniesAsync, updateCompanyAsync, deleteCompanyAsync } from './companyThunk';
const initialState = {
    companiesByRegion: [],
    companies: [],
    allCompanies: [],
    selectedCompanyId: [],
    status: APIStatus.IDLE,
    updateStatus: APIStatus.IDLE,
    deleteStatus: APIStatus.IDLE,
    apiError: undefined
};
export const companySlice = createSlice({
    name: 'company',
    initialState,
    reducers: {
        setSelectedCompanyId(state, action) {
            state.selectedCompanyId = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllUserCompaniesAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllUserCompaniesAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.companiesByRegion = action.payload;
            state.companies = action.payload.flatMap((r) => r.companies);
        })
            .addCase(getAllUserCompaniesAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(getAllCompaniesAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllCompaniesAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.allCompanies = action.payload;
        })
            .addCase(getAllCompaniesAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(updateCompanyAsync.pending, (state) => {
            state.updateStatus = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateCompanyAsync.fulfilled, (state, action) => {
            state.updateStatus = APIStatus.SUCCESS;
            const index = state.allCompanies.findIndex((c) => c.id === action.payload.id);
            if (index !== -1)
                state.allCompanies[index] = action.payload;
        })
            .addCase(updateCompanyAsync.rejected, (state, action) => {
            state.updateStatus = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(deleteCompanyAsync.pending, (state) => {
            state.deleteStatus = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteCompanyAsync.fulfilled, (state) => {
            state.deleteStatus = APIStatus.SUCCESS;
        })
            .addCase(deleteCompanyAsync.rejected, (state, action) => {
            state.deleteStatus = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { setSelectedCompanyId } = companySlice.actions;
export default companySlice.reducer;
